var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejectedVerification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M24 12C24 15.1826 22.7358 18.2349 20.4853 20.4853C18.2349 22.7357 15.1827 24 12.0001 24C8.81748 24 5.76526 22.7357 3.51482 20.4853C1.26438 18.2349 1.00239e-06 15.1826 0 12C0 8.8174 1.26438 5.76516 3.51482 3.51472C5.76526 1.26428 8.81748 0 12.0001 0C15.1827 0 18.2349 1.26428 20.4853 3.51472C22.7358 5.76516 24 8.8174 24 12Z",
    fill: "#853F49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9333 12L15.8 9.13333C16.0667 8.86667 16.0667 8.46667 15.8 8.2C15.5333 7.93333 15.1333 7.93333 14.8667 8.2L12 11.0667L9.13333 8.2C8.86667 7.93333 8.46667 7.93333 8.2 8.2C7.93333 8.46667 7.93333 8.86667 8.2 9.13333L11.0667 12L8.2 14.8667C8.06667 15 8 15.1333 8 15.3333C8 15.7333 8.26667 16 8.66667 16C8.86667 16 9 15.9333 9.13333 15.8L12 12.9333L14.8667 15.8C15 15.9333 15.1333 16 15.3333 16C15.5333 16 15.6667 15.9333 15.8 15.8C16.0667 15.5333 16.0667 15.1333 15.8 14.8667L12.9333 12Z",
    fill: "#BA4D5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedVerification);
export default __webpack_public_path__ + "static/media/rejectedVerification.27a03ef7ffce39348074151ced82416c.svg";
export { ForwardRef as ReactComponent };